export var CREATE_STYLE_REQUEST = 'src/StyleNew/CREATE_STYLE_REQUEST';
export var CREATE_STYLE_SUCCESS = 'src/StyleNew/CREATE_STYLE_SUCCESS';
export var CREATE_STYLE_FAILURE = 'src/StyleNew/CREATE_STYLE_FAILURE';
